export default "__VITE_ASSET__Bm_8cGUt__"